import { render, staticRenderFns } from "./NotApplyForCWPDataTable.vue?vue&type=template&id=f2c7b200&scoped=true"
import script from "./NotApplyForCWPDataTable.vue?vue&type=script&lang=js"
export * from "./NotApplyForCWPDataTable.vue?vue&type=script&lang=js"
import style0 from "./NotApplyForCWPDataTable.vue?vue&type=style&index=0&id=f2c7b200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7b200",
  null
  
)

export default component.exports